/* eslint-disable jira/filename-case */
import { getNavigateToTeamsApp } from '@jira/platform__teams-app-config/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Users, Groups } from '../../model/index.tsx';

export const createUserUrl = (id: string): string => {
	if (fg('jira-adopt-teams-nav-config')) {
		const { href } = getNavigateToTeamsApp({
			type: 'USER',
			payload: {
				userId: id,
			},
		});
		return href;
	}
	return `/jira/people/${id}`;
};

export const transformResponse = (response: {
	subscriptions: {
		items: [];
	};
}): {
	users: Users;
	groups: Groups;
} => {
	const subscriptions = (response && response.subscriptions && response.subscriptions.items) || [];
	const users: Array<{
		readonly displayName: string;
		readonly href: string;
	}> = [];
	const groups: Array<{
		readonly name: string;
	}> = [];

	subscriptions.forEach((subscription) => {
		const { user, group } = subscription;
		if (group) {
			return groups.push({
				// @ts-expect-error - TS2339 - Property 'name' does not exist on type 'never'.
				name: group.name,
			});
		}
		// @ts-expect-error - TS2339 - Property 'accountId' does not exist on type 'never'.
		const href = createUserUrl(user.accountId);

		return (
			user &&
			users.push({
				// @ts-expect-error - TS2339 - Property 'displayName' does not exist on type 'never'.
				displayName: user.displayName,
				href,
			})
		);
	});

	return { users, groups };
};
